import script from "./BarNotasChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BarNotasChart.vue?vue&type=script&setup=true&lang=js"

import "./BarNotasChart.vue?vue&type=style&index=0&id=119e6f0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-119e6f0f"]])

export default __exports__